export default {
  // Hero
  bookHeroLabel: 'Direktbuchung',
  bookHeroTitle: 'Verfügbarkeit prüfen.\nDirekt buchen.',
  bookHeroText: 'Wählen Sie Ihre Wunschtermine, prüfen Sie freie Zimmer und buchen Sie zum Bestpreis – ohne Umwege.',

  // Buchungssystem
  bookSystemTitle: 'Online buchen',
  bookSystemSub: 'Echtzeit-Verfügbarkeit & sofortige Bestätigung',
  bookPhoneLabel: 'Telefonisch:',

  // Hinweise
  bookNotesTitle: 'Wichtige Hinweise',
  bookNote1: 'Check-in ab 15 Uhr',
  bookNote2: 'Check-out bis 12 Uhr',
  bookNote3: 'Frühstück 7–10 Uhr, Wochenende/Feiertags 8–11 Uhr',
  bookNote4: 'Kostenfreie Parkplätze',
  bookNote5: 'Kostenloses WLAN',
  bookNote6: 'Haustiere nicht erlaubt',

  // Zimmerübersicht
  bookRoomsTitle: 'Unsere Zimmerkategorien',
  bookRoom1Name: 'Doppelzimmer',
  bookRoom1Details: '2 Personen',
  bookRoom1Price: 'ab 179 €',
  bookRoom2Name: 'Einzelzimmer',
  bookRoom2Details: '1 Person',
  bookRoom2Price: 'ab 99 €',
  bookRoom3Name: 'Komfort-Doppelzimmer',
  bookRoom3Details: '30 m² · 2 Personen',
  bookRoom3Price: 'ab 199 €',

  // Beratung
  bookAdviceTitle: 'Beratung gewünscht?',
  bookAdviceText: 'Rufen Sie uns gern an oder schreiben Sie uns – wir helfen bei der Auswahl.',
};
